import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  // url: 'https://www.fnrddbyj.com',
	  // daibiaoUrl: 'https://www.fnrddbyj.com',
	  // xuanminUrl:'https://xuanmin.fnrddbyj.com',
	  // iframeUrl:'https://www.fnrddbyj.com',
	  
	  //放云软服务器的
	  url: 'https://www.fnrddbyj.com',  //data_center是后台的模块名  要和后台的模块名保持一致
	  daibiaoUrl: 'https://daibiao-fnrddbyj.yriis.cn', //代表版彈窗
	  xuanminUrl:'https://xuanmin-fnrddbyj.yriis.cn',    //選民版彈窗地址
	  iframeUrl:'https://fnrddbyj.yriis.cn', //弹窗地址
	  
	  
	  // url: 'http://2.136.150.3:666',
	  // daibiaoUrl: 'http://2.136.150.3:666/zhengwuyun',
	  // xuanminUrl: 'http://2.136.181.211:666/zhengwuyun',
	  // iframeUrl:'http://2.136.150.3:666/zhengwuyun',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
